import { formatRelativeTime, minutesSince } from "@/lib/format";
import type { ChannexSyncOp, ChannexSyncState } from "@/types";

export const SYNC_OP_LABEL: Record<ChannexSyncOp, string> = {
  content: "콘텐츠(양방향)",
  availability: "재고·요금(푸시)",
};

/**
 * 한 방향의 마지막 동기화 결과 한 칸. 채널 화면과 슈퍼어드민이 같은 규칙으로 그린다.
 *
 * **미동기화(state 없음)를 정상으로 칠하지 않는다** — 한 번도 안 돈 방향은 회색
 * "미동기화"이고, 마지막 성공이 임계치보다 오래됐으면 성공이어도 "오래됨"으로 경고한다
 * (워커가 죽으면 실패조차 기록되지 않아 이게 유일한 신호다).
 */
export function SyncStatusCell({
  state,
  staleAfterMinutes,
  now,
}: {
  state: ChannexSyncState | undefined;
  staleAfterMinutes: number;
  now?: Date;
}) {
  if (!state) {
    return <span className="text-muted-foreground">미동기화</span>;
  }
  const sinceOk = minutesSince(state.ok_at, now);
  const stale = sinceOk === null || sinceOk > staleAfterMinutes;
  const failed = state.status === "failed";
  const tone = failed
    ? "bg-red-100 text-red-600"
    : stale
      ? "bg-amber-100 text-amber-700"
      : "bg-green-100 text-green-700";
  const label = failed ? `실패 ${state.failures}회` : stale ? "오래됨" : "정상";
  return (
    <div className="space-y-0.5">
      <span className={`inline-flex items-center rounded-full px-2 py-0.5 font-medium ${tone}`}>
        {label}
      </span>
      <p className="tabular-nums text-muted-foreground">
        {state.ok_at ? `마지막 동기화 ${formatRelativeTime(state.ok_at, now)}` : "성공한 적 없어요"}
      </p>
      {failed && state.error && <p className="text-destructive">{state.error}</p>}
    </div>
  );
}
